export { default as OwnerCreatePostFormNews } from './SubformNews'
